import { useEffect, useState } from "react";
import { api } from "./api";
import { useAuth } from "../contexts/AuthContext";

/** Live cart-count subscriber — listens to the existing ``cart:update``
 * event the rest of the app already dispatches, so this stays in sync
 * without any new context. Originally local to MarketplaceHome.jsx;
 * extracted here so any page's header can show the same live badge. */
export function useCartCount() {
    const { user } = useAuth();
    const [count, setCount] = useState(0);
    useEffect(() => {
        if (!user) { setCount(0); return; }
        let alive = true;
        const fetch = async () => {
            try {
                const { data } = await api.get("/cart");
                if (!alive) return;
                const n = (data?.items || []).reduce((s, i) => s + (i.quantity || 0), 0);
                setCount(n);
            } catch { /* ignore — pre-auth or empty cart */ }
        };
        fetch();
        const onUpdate = () => fetch();
        window.addEventListener("cart:update", onUpdate);
        return () => { alive = false; window.removeEventListener("cart:update", onUpdate); };
    }, [user]);
    return count;
}
